import { CommissionDistribution } from "./commission-distribution";
import { Target } from "./target";
import { User } from "./user";
import { Sale } from "./sale";

import Disable from "./commission/disable";

export const OffcanvasForm = { User, CommissionDistribution, Sale, Target, Disable };
